"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getObjectProperty = void 0;
Object.defineProperty(exports, "omit", {
  enumerable: true,
  get: function () {
    return _lodashEs.omit;
  }
});
Object.defineProperty(exports, "pick", {
  enumerable: true,
  get: function () {
    return _lodashEs.pick;
  }
});
var _lodashEs = require("lodash-es");
const getObjectProperty = (object, key) => object && object[key] !== undefined ? object[key] : null;
exports.getObjectProperty = getObjectProperty;